// extracted by mini-css-extract-plugin
export default {"confirmation-overlay":"confirmation__confirmation-overlay___1KtkH"};